import { createRouter, createWebHistory } from "vue-router"
import type { Component } from "vue"

import MainLayout from "@/layouts/MainLayout.vue"

import ServicesIndex from "@/views/ServicesIndex.vue"
import PaymentDetail from "@/views/PaymentDetail.vue"
import ServicePaymentCreate from "@/views/ServicePaymentCreate.vue"

declare module "vue-router" {
  interface RouteMeta {
    pageTitle?: string
    icon?: Component
  }
}

const { setPageTitle } = usePageTitle()
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      component: MainLayout,

      children: [
        {
          path: "",
          name: "home",
          component: ServicesIndex,
          meta: {
            pageTitle: "Home",
          },
        },
        {
          path: "service/:serviceId/request",
          component: ServicePaymentCreate,
          name: "servicePaymentCreate",
          props: true,
        },
        {
          path: "payments/:paymentId",
          component: PaymentDetail,
          name: "paymentDetail",
          props: true,
        },
      ],
    },

    {
      path: "/:pathMatch(.*)",
      redirect: {
        name: "home",
      },
    },
  ],
})

router.beforeEach((to) => {
  setPageTitle(to.meta.pageTitle || "")
  return true
})

export default router
